import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { datePickerValidator } from '@app/core/Directives/datepicker-validator';
import {
  ChartOfAccountCurrentLiabilitiesGroupTypeName,
  GroupNames,
  NotificationTextMessage,
} from '@app/core/Enum';
// import { AccountNumber } from '@app/core/Enum/account-number';
import {
  ChartOfAccountListParam,
  GlobalComponent,
  SideListModel,
} from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import {
  GetFundNameList,
  GetGroupAccountsBasedOnGroupIdAndTypeId,
  GetGroupCustomBankAndCashAccount,
  UpdatePaymentStatus,
} from '@app/core/Store';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-vat-payment-popup',
  templateUrl: './vat-payment-popup.component.html',
  styleUrls: ['./vat-payment-popup.component.scss'],
})
export class VatPaymentPopupComponent implements OnInit {
  vatId: any;
  vatPaymentForm: FormGroup;
  isPostJournal: boolean = false;
  periodicDate: any;
  receiptAccountList: any[] = [];
  tempReceiptAccountList: any[];
  fundNameList: SideListModel[];
  notificationMessage = NotificationTextMessage;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private renderer: Renderer2,
    private store: Store,
    public datepipe: DatePipe,
    public commonService: CommonService,
    public dialogRef: MatDialogRef<VatPaymentPopupComponent>,
    private globalComponent: GlobalComponent
  ) { }

  ngOnInit(): void {
    this.periodicDate = this.globalComponent.getFinancialPeriod();
    this.setForm();
    this.vatId = this.data.id;
    this.vatPaymentForm.controls.vatAmount.setValue(this.data.netVatDue);
  }

  setForm(): void {
    this.vatPaymentForm = new FormGroup({
      paymentDate: new FormControl(new Date(), [
        datePickerValidator(this.periodicDate),
        Validators.required,
      ]),
      reference: new FormControl(''),
      postJournal: new FormControl(false),
      accountId: new FormControl(''),
      fundId: new FormControl(''),
      vatAmount: new FormControl({ value: 0, disabled: true }),
    });
    this.onAccountTypeChange();
    this.getFund();
  }

  onAccountTypeChange(): void {
    let actionName;

    actionName = GetGroupCustomBankAndCashAccount;

    this.vatPaymentForm.controls.accountId.setValue('');

    this.store
      .dispatch(new actionName())
      .pipe(
        tap((res) => {
          this.receiptAccountList = [];
          this.receiptAccountList = this.commonService.addGroupNameToListModels(
            res.common.customBankAndCashAccountGroupList
          );
          this.tempReceiptAccountList = this.receiptAccountList;
        })
      )
      .subscribe();
  }

  getFund(): void {
    this.store
      .dispatch(new GetFundNameList())
      .pipe(
        tap((res) => {
          this.fundNameList = res.account.fundNameList;

          if (this.fundNameList.length > 0) {
            this.vatPaymentForm.controls.fundId.setValue(
              this.fundNameList[0].id
            );
          }
        })
      )
      .subscribe();
  }

  onCheckBoxSelected(event: any): void {
    this.isPostJournal = event.checked;
    if (this.isPostJournal) {
      this.vatPaymentForm.get('accountId')?.setValidators(Validators.required);
      this.vatPaymentForm.get('accountId')?.updateValueAndValidity();
    } else {
      this.vatPaymentForm.get('accountId')?.clearValidators();
      this.vatPaymentForm.get('accountId')?.updateValueAndValidity();
    }
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.vatPaymentForm.invalid) {
      this.commonService.addValidation(this.vatPaymentForm, this.renderer);
    } else {
      this.store
        .dispatch(new UpdatePaymentStatus(this.dataSubmit()))
        .pipe()
        .subscribe(
          (res) => {
            if (res !== undefined) {
              this.onCloseClick();
              this.commonService.onSucess(
                NotificationTextMessage.successMessage
              );
            } else {
              this.commonService.onFailure(
                NotificationTextMessage.errorMessage
              );
            }
          },
          (err) => {
            this.commonService.onFailure(err.message);
          }
        );
    }
  }

  dataSubmit(): any {
    let data = {
      id: this.vatId,
      paymentDate: this.datepipe
        .transform(this.vatPaymentForm.controls.paymentDate.value, 'yyyy-MM-dd')
        ?.toString(),
      description: this.vatPaymentForm.controls.reference.value,
      isPostJournal: this.vatPaymentForm.controls.postJournal.value,
      fromAccount:
        this.vatPaymentForm.controls.accountId.value !== undefined &&
          this.vatPaymentForm.controls.accountId.value !== null &&
          this.vatPaymentForm.controls.accountId.value !== ''
          ? this.vatPaymentForm.controls.accountId.value
          : null,
      fundId : this.vatPaymentForm.controls.fundId.value,
    };

    return data;
  }
}

